import { LazyLoadImage } from "react-lazy-load-image-component"

export const NoData = () => {
    return (
        <>
            <LazyLoadImage effect='blur' src='https://ik.imagekit.io/gplanet/Gplanet/img/NODATA_IMG-01.png?updatedAt=1701510157293' width='100%' />
        </>
    )
}